<template>
    <div>
        <div class="p-6 mb-15 shadow-md rounded-md">
            <div class="grid md:grid-cols-4 gap-2">
                <label class="block text-sm">
                    <span class="text-lg font-semibold leading-6 mb-2.5">From</span>
                    <jet-input type="date"
                               v-model="startDateValue"
                               @change.prevent="filterByDate"
                               class="block w-full mt-1">
                    </jet-input>
                </label>
                <label class="block text-sm">
                    <span class="text-lg font-semibold leading-6 mb-2.5">To</span>
                    <jet-input type="date"
                               v-model="endDateValue"
                               @change.prevent="filterByDate"
                               class="block w-full mt-1">
                    </jet-input>
                </label>
                <div></div>
                <inertia-link class="ml-auto" :href="route('admin.dashboard.template-survey-scores')">
                    <jet-button>
                        Explore template scores
                    </jet-button>
                </inertia-link>
            </div>
            <span class="text-md font-semibold mt-2 block">Below data is related to surveys created within the filtered period (ex: total revenue for surveys that were created within the filtered interval)</span>
        </div>

        <super-admin-survey-stats v-for="(surveyType,surveyTypeIndex) in surveyTypes"
                                  :key="'surveyType-' + surveyTypeIndex"
                                  :survey-type="surveyType"
                                  :survey-type-stats="surveyTypeStats[surveyType.id]"
       />

    </div>
</template>

<script>
import SuperAdminSurveyStats from "@/Components/SuperAdminDashboard/SuperAdminSurveyStats";
import SurveyCard from "@/Components/SurveyCard";
import JetInput from "@/Jetstream/Input";
import JetButton from "@/Jetstream/Button";
import Pill from "@/Jetstream/Pill";
import {usePage} from "@inertiajs/inertia-vue3";
import {ref} from "vue";
import {Inertia} from "@inertiajs/inertia";

export default {
    name: "SuperAdminDashboard",
    components: {
        SurveyCard,
        SuperAdminSurveyStats,
        JetInput,
        JetButton,
        Pill
    },
    setup() {
        const {surveyTypes, surveyTypeStats, startDate, endDate} = usePage().props.value;

        const startDateValue = ref(startDate);
        const endDateValue = ref(endDate);

        const filterByDate = () => {
            Inertia.visit(route('dashboard', {startDate: startDateValue.value, endDate: endDateValue.value}))
        };

        return {
            surveyTypes,
            surveyTypeStats,
            startDateValue,
            endDateValue,
            filterByDate,
        }
    }
}
</script>

<style scoped>

</style>
